import { create } from "zustand";

interface AddCurriculumStore {
    isOpen: boolean;
    open: () => void;
    close: () => void;
}

const useAddCurriculumModal = create<AddCurriculumStore>((set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false })
}));

export default useAddCurriculumModal;